import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { FormControl, Typography } from "@mui/material";
import useSWR, { useSWRConfig } from "swr";
import { useDispatch, useSelector } from "react-redux";
import useSWRMutation from "swr/mutation";
import { useNavigate } from "react-router";

import LoginFooter from "../LoginFooter";
import LoginHeader from "../LoginHeader";
import { fetcherPatch } from "../../../../services/fetcher";
import {
  getSettingState,
  setSnackbarMode,
  setSnackbarTitle,
} from "../../../../redux/features/settingSlice";
import UseWindowDimensions from "./../../../../utils/windowSize";
import CustomInput from "../../CustomInput";
import CustomHelmet from "../../CustomHelmet";

const EditNamePage = () => {
  const [userName, setUserName] = useState("");
  const [name, setName] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { height } = UseWindowDimensions();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const { userData } = useSelector(getSettingState);
  const { mutate } = useSWRConfig();

  const { data: profile } = useSWR(
    () => {
      if (!userData) {
        return null;
      }
      return `${process.env.REACT_APP_API}/auth/profile/${userData}/`;
    },
    {
      dedupingInterval: 1000,
    }
  );

  const { trigger, isMutating } = useSWRMutation(
    [`${process.env.REACT_APP_API}/auth/profile/update/`, tokenStorage],
    fetcherPatch,
    {
      onSuccess: () => {
        dispatch(setSnackbarMode(true));
        dispatch(setSnackbarTitle("Your information has been updated"));
        navigate("/login/editavatar");
      },
    }
  );

  // set name after load
  useEffect(() => {
    profile?.username && setUserName(profile.username);
    profile?.nickname && setName(profile.nickname);
  }, [profile]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (userName.length < 3 || userName.length > 20) {
      dispatch(setSnackbarMode(true));
      dispatch(setSnackbarTitle("Username between 3 and 15 characters"));
      return;
    }
    if (name.length < 3 || name.length > 20) {
      dispatch(setSnackbarMode(true));
      dispatch(setSnackbarTitle("name between 3 and 15 characters"));
      return;
    }

    const formData = new FormData();
    userName && formData.append("username", userName);
    name && formData.append("nickname", name);

    try {
      await trigger(formData);
      mutate(`${process.env.REACT_APP_API}/auth/profile/${userData}/`);
    } catch {}
  };

  return (
    <>
      <CustomHelmet title={`Edit name | Azad`} />
      <Box sx={{ height: "100%", backgroundColor: "white.main" }}>
        <LoginHeader type='editName' />
        <Box
          sx={{
            display: "flex",
            height: height + "px",
            alignItems: "end",
          }}
        >
          <Box sx={{ width: "100%", mb: "72px", mt: "100px" }}>
            <Box sx={{ px: "16px", mb: "32px" }}>
              <Typography
                sx={{
                  fontSize: "40px",
                  fontWeight: 700,
                  fontFamily: "Tahrir",
                  lineHeight: "40px",
                  mb: "14px",
                }}
              >
                Welcome To Azad
              </Typography>
              <Typography
                sx={{
                  fontSize: "20px",
                  lineHeight: "28px",
                }}
              >
                Here are 3 easy steps to prepare your profile. You can skip
                these steps if you want.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                border: "2px solid",
                borderColor: "black.main",
                padding: "24px 16px",
                borderRadius: "16px 16px 0 0",
              }}
            >
              <Typography
                sx={{ fontSize: "20px", lineHeight: "28px", mb: "22px" }}
              >
                Please edit your information.
              </Typography>

              <FormControl
                component={"form"}
                onSubmit={handleSubmit}
                sx={{
                  width: "100%",
                }}
                variant='outlined'
              >
                <Box sx={{ mb: "22px" }}>
                  <CustomInput
                    loading={!profile}
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    label='UserName'
                    helperText='Your username makes your profile address in Azad'
                    icon='@'
                    minLength={3}
                    maxLength={30}
                    req
                  />
                </Box>
                <Box>
                  <CustomInput
                    loading={!profile}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    label='Name'
                    helperText='Other users will know you by your name'
                    minLength={3}
                    maxLength={30}
                    req
                  />
                </Box>
                <LoginFooter type='editName' disabled={isMutating} />
              </FormControl>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default EditNamePage;
